import React from "react";
import { SEASON_PHASE_META } from "../constants";
import { leagueLedgerSubline } from "../helpers";

export default function LeaguesFloorRow({ league, selected, onSelect }) {
  const phase = league.seasonPhase || "unknown";
  const phaseMeta = SEASON_PHASE_META[phase] || SEASON_PHASE_META.unknown;

  return (
    <button
      type="button"
      className={`amf-row alg-row ${selected ? "amf-row-selected" : ""} ${league.isEnabled ? "" : "alg-row-off"} alg-row-${phase}`}
      aria-pressed={selected}
      onClick={onSelect}
    >
      <span className="alg-row-logo">
        {league.logo ? (
          <img src={league.logo} alt="" />
        ) : (
          <span className="alg-row-logo-fallback">{league.name?.[0] || "?"}</span>
        )}
      </span>
      <span className="amf-row-body alg-row-body">
        <span className="amf-row-top alg-row-top">
          <span className="amf-row-name">{league.name}</span>
          <span className={`amf-row-tag ${phaseMeta.tag}`}>{phaseMeta.label}</span>
          {!league.isEnabled ? (
            <span className="amf-row-tag amf-row-tag-muted">Off</span>
          ) : null}
        </span>
        <span className="amf-row-sub alg-row-sub">{leagueLedgerSubline(league)}</span>
      </span>
    </button>
  );
}
